import React from "react";
import { Link } from "react-router-dom";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

import tata_new from "./images/company/tata_new.jpg";
import usha from "./images/company/usha";
import mahindra from './images/company/mahindra'
import kidzee from './images/company/kidzee.png'

import logo_shree from './images/company/logo_shree.png'
import mutha_logo from './images/company/mutha_logo.png'
import hridayam_logo from './images/company/hridayam_logo.png'
import wealth_logo from './images/company/wealth_logo.png'
import rpdaga_logo from './images/company/rpdaga_logo.png'
import naresh_logo from './images/company/naresh_logo.png'
import guddi_logo from './images/company/guddi_logo'
import plus_logo from './images/company/plus_logo.png'
import varad_logo from './images/company/varad_logo.png'


import mutha from "../assets/img/mutha.jpeg";
import shree from "../assets/img/shree.jpeg";
import varad from "../assets/img/varadinfra.jpeg";
import rpdaga from "../assets/img/rpdaga.jpeg";
import naresh from "../assets/img/naresh.jpeg";
import saisuvidha from "../assets/img/saisuvidha.jpeg";
import plus from "../assets/img/plus.jpeg";
import hridayam from "../assets/img/hridayam.jpeg";
import wealth from "../assets/img/wealth.jpeg";

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';


import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
// import TabPanel from '@mui/material/TabPanel';
import Box from '@mui/material/Box';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import topnotch_video from './video/topnotch_video'

import computers from './images/computers'
import chart from './images/chart'


import topnotch_1 from './images/topnotch/topnotch_1'
import topnotch_2 from './images/topnotch/topnotch_2'
import topnotch_3 from './images/topnotch/topnotch_3'
import topnotch_4 from './images/topnotch/topnotch_4'
import topnotch_5 from './images/topnotch/topnotch_5'
import topnotch_6 from './images/topnotch/topnotch_6'
import topnotch_7 from './images/topnotch/topnotch_7'
import topnotch_8 from './images/topnotch/topnotch_8'
import topnotch_9 from './images/topnotch/topnotch_9'
import topnotch_10 from './images/topnotch/topnotch_10'

import img_team_1 from './images/team/img_team_1'
import img_team_2 from './images/team/img_team_2'
import img_team_3 from './images/team/img_team_3'
import shubham_2 from './images/team/shubham_2'

import { motion } from "framer-motion";

import { styles } from "../styles";
import { ComputersCanvas } from "./canvas";
import { TypeAnimation } from "react-type-animation";
import ParticlesNew from "../components/particles/ParticlesNew";
import { useState } from "react";
import { Container, Grid } from "@mui/material";

function srcset(image, size, rows = 1, cols = 1) {
  return {
    src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
    srcSet: `${image}?w=${size * cols}&h=${
      size * rows
    }&fit=crop&auto=format&dpr=2 2x`,
  };
}
export default function About() {

  const itemData = [
    {
      img: 'https://images.unsplash.com/photo-1551963831-b3b1ca40c98e',
      title: 'Breakfast',
      rows: 2,
      cols: 2,
    },
    {
      img: 'https://images.unsplash.com/photo-1551782450-a2132b4ba21d',
      title: 'Burger',
    },
    {
      img: 'https://images.unsplash.com/photo-1522770179533-24471fcdba45',
      title: 'Camera',
    },
    {
      img: 'https://images.unsplash.com/photo-1444418776041-9c7e33cc5a9c',
      title: 'Coffee',
      cols: 2,
    },
    {
      img: 'https://images.unsplash.com/photo-1533827432537-70133748f5c8',
      title: 'Hats',
      cols: 2,
    },
    {
      img: 'https://images.unsplash.com/photo-1558642452-9d2a7deb7f62',
      title: 'Honey',
      author: '@arwinneil',
      rows: 2,
      cols: 2,
    },
    {
      img: 'https://images.unsplash.com/photo-1516802273409-68526ee1bdd6',
      title: 'Basketball',
    },
    {
      img: 'https://images.unsplash.com/photo-1518756131217-31eb79b20e8f',
      title: 'Fern',
    },
    {
      img: 'https://images.unsplash.com/photo-1597645587822-e99fa5d45d25',
      title: 'Mushrooms',
      rows: 2,
      cols: 2,
    },
    {
      img: 'https://images.unsplash.com/photo-1567306301408-9b74779a11af',
      title: 'Tomato basil',
    },
    {
      img: 'https://images.unsplash.com/photo-1471357674240-e1a485acb3e1',
      title: 'Sea star',
    },
    {
      img: 'https://images.unsplash.com/photo-1589118949245-7d38baf380d6',
      title: 'Bike',
      cols: 2,
    },
  ];
  const [value, setValue] = useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>


<section className="bannerSec">
  <div className="banner-video">
    <video  
      preload="auto"
      // poster="https://instagram.fbom6-1.fna.fbcdn.net/v/t51.2885-15/315340462_795489534888290_901706451820765616_n.jpg?stp=dst-jpg_e35_s640x640_sh0.08&_nc_ht=instagram.fbom6-1.fna.fbcdn.net&_nc_cat=102&_nc_ohc=tZw9BzyT2d8AX96Jchb&edm=AP_V10EBAAAA&ccb=7-5&oh=00_AfA9SmJRrX0UCxTcOYgrn5EuzGgBIlWXNRocmTr1sLRDaA&oe=64475CFD&_nc_sid=4f375e
      // "
      autoPlay
      muted
      loop
      // controls
    >
      <source
        src={topnotch_video}
        type="video/mp4"
      />
    </video>
  </div>
  <style dangerouslySetInnerHTML={{ __html: "" }} />
  <div className="homeSlider">
    <div className="item" >
      <div className="bannerCon">
        <span className="bannerSmallTitle">Looking For Business Setup in</span>
        <strong className="bannerTitle">Top Notch Media Works</strong>
        <span className="bannerSecTitle">
      A  Best  marketing Company
        </span>
        <span className="bannerSecTitle">
   #360 Degree Marketing Solution
        </span>
        <span className="bannerDivider" />
        {/* <p>
          PRO Services | Visa Processing | Bank Account Opening | Trade License
          | Dubai Office Space
        </p> */}
        {/* <button
          type="button"
          className="btn btn-dark calculateBtn"
          data-toggle="modal"
          data-target="#costCalculatorModal"
        >
          Calculate Cost
        </button> */}
        {/* <a
          className="btn"
          href="https://www.makemyfirm.ae/companyformation-businessetup-uae/"
        >
          OUR PACKAGES <i className="icon icon-arrow-right" />
        </a> */}
      </div>
    </div>
    <div className="item" style={{ display: "none" }}>
      <div className="bannerCon">
        <span className="bannerSmallTitle">Trusted &amp; Experienced</span>
        <strong className="bannerTitle">Company</strong>
        <span className="bannerSecTitle">Setup Consultant UAE</span>
        <span className="bannerDivider" />
        {/* <p>UAE Mainland | UAE Freezone | Offshore Business</p> */}
        {/* <button
          type="button"
          className="btn btn-dark calculateBtn"
          data-toggle="modal"
          data-target="#costCalculatorModal"
        >
          Calculate Cost
        </button>
        <a
          className="btn"
          href="https://www.makemyfirm.ae/companyformation-businessetup-uae/"
        >
          OUR PACKAGES <i className="icon icon-arrow-right" />
        </a> */}
      </div>
    </div>
  </div>
</section>

   


{/* about section 2 */}
<section>
  <div className="mt-1" style={{backgroundColor:"#2A2342"}}>
  <div className="container">
    <div className="row">
      <div className="col-lg-12 col-md-6 col-sm-6 p-5">
        <h1 className="mt-3 text-center">ABOUT US</h1>
        <p className="text-light mt-3">Top notch media works is one of the best branding agencies in Maharashtra. We provide best and innovative solutions with strong strategy and creative ideas as well as overcome the business challenges in a right way that would give your business a way to step a higher level. We provide services such as web designing, strategic planning, staff and owner training, digital media, print media etc. that would make your business add an extra amount of profitability in the industry. We are a full service media company and our main objective is to increase the efficiency and profitability of our customer’s business. We make you future ready by developing responsive sites and integrated web solutions to give a shape to your brand’s journey in the digital arena. Get yourself future ready with us! </p>

      </div>
    </div>
  </div>
  </div>
</section>

      {/* ABout us section start */}
      <div className="home-bg-img" style={{color:"secondary"}}>
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-8ee92bb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8ee92bb"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      
      >
        <div className="elementor-container elementor-column-gap-default"
          // style={{backgroundImage:`url${Home_page_BG_1}`}}
          
        >
          <div
            className=" elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b9a4717"
            data-id="b9a4717"
            data-element_type="column"
          >
            <div className="elementor-widget-wrap elementor-element-populated">
              <div
                className="elementor-element elementor-element-cb648cc elementor-widget elementor-widget-spinner_heading"
                data-id="cb648cc"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
        style={{color:"#fff"}}

              >
                <div className="elementor-widget-container">
                  <div className="section-title  primary4 position-relative">
                    <span>-About Our Company-</span>
                    <h3 className="text-animate" style={{ color: "#fff"}}>
                      We are committed to provide our customers with
                      exceptional.
                    </h3>
                    <p className="para mb-0" style={{ color: "#fff"}}>
                      We make you future ready by developing responsive sites
                      and integrated web solutions to give Link shape to your
                      brand’s journey in the digital arena. Get yourself future
                      ready with us!
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="elementor-element elementor-element-828aa89 elementor-list-item-link-inline elementor-align-left elementor-icon-list--layout-traditional elementor-widget elementor-widget-icon-list"
                data-id="828aa89"
                data-element_type="widget"
                data-widget_type="icon-list.default"
              >
                <div className="elementor-widget-container ">
                  <link
                    rel="stylesheet"
                    href="#"
                  />
                  <ul className="elementor-icon-list-items">
                    <li className="elementor-icon-list-item">
                      <span className="elementor-icon-list-icon">
                        <i
                          aria-hidden="true"
                          className="bi bi-circle-fill text-danger"
                        ></i>
                      </span>
                      <span className="elementor-icon-list-text">
                        An Effective Brand Strategy Gives You A Major Edge In
                        Increasingly Competitive Markets.
                      </span>
                    </li>
                    <br />
                    <li className="elementor-icon-list-item">
                      <span className="elementor-icon-list-icon">
                        <i
                          aria-hidden="true"
                          className="bi bi-circle-fill text-danger"
                        ></i>
                      </span>
                      <span className="elementor-icon-list-text">
                        An Honest And Results Driven Creative Agency
                      </span>
                    </li>
                    <br />
                    <li className="elementor-icon-list-item">
                      <span className="elementor-icon-list-icon">
                        <i
                          aria-hidden="true"
                          className="bi bi-circle-fill  text-danger "
                        ></i>
                      </span>
                      <span className="elementor-icon-list-text">
                        Focus Your Time And Efforts On Running Your Business And
                        Leave The Marketing On Us
                      </span>
                    </li>
                    <br />
                  </ul>
                </div>
              </div>
              <div
                className="elementor-element elementor-element-4ca47ad elementor-widget elementor-widget-spinner_button"
                data-id="4ca47ad"
                data-element_type="widget"
                data-widget_type="spinner_button.default"
              >
                <div className="elementor-widget-container">
                  <div
                    className="about1-content wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.2s"
                  >
                    <Link to="/about" className="eg-btn btn--primary btn--lg">
                      Know More
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1000224"
            data-id="1000224"
            data-element_type="column"
          >
            <div className="elementor-widget-wrap elementor-element-populated">
              <div
                className="elementor-element elementor-element-389eeb3 elementor-widget elementor-widget-spinner_about"
                data-id="389eeb3"
                data-element_type="widget"
                data-widget_type="spinner_about.default"
              >
                <div className="elementor-widget-container">
                  <div className="order-lg-2 order-1">
                    <div
                      className="about-images wow fadeInRight"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.2s"
                    >
                      <div className="row g-0">
                        <div className="col-6 about11">
                          <img
                            decoding="async"
                            // src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/about11.png"
                            src={img_team_1}
                            className="about11 img-fluid"
                            alt="About Image"
                          />
                          <div className="experience-tag">
                            <div className="tag-inner">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="36"
                                height="36"
                                viewBox="0 0 36 36"
                                fill="none"
                              >
                                <g clipPath="url(#clip0_333_388)">
                                  <path
                                    d="M17.55 0.182813C17.4023 0.330469 17.3672 0.435938 17.3672 0.703125C17.3672 0.970313 17.4023 1.07578 17.55 1.22344C17.6977 1.37109 17.8031 1.40625 18.0703 1.40625C18.3375 1.40625 18.443 1.37109 18.590px6 1.22344C18.7383 1.07578 18.7734 0.970313 18.7734 0.703125C18.7734 0.435938 18.7383 0.330469 18.590px6 0.182813C18.443 0.0351562 18.3375 0 18.0703 0C17.8031 0 17.6977 0.0351562 17.55 0.182813Z"
                                    fill="#E90px04F"
                                  ></path>
                                  <path
                                    d="M13.90px08 0.625786C11.8266 1.30782 9.92109 2.50313 8.43047 4.05704C6.6375 5.92032 5.43516 8.2336 4.90px078 10.8563C4.76719 11.5383 4.74609 11.8547 4.74609 13.3594C4.74609 14.8641 4.76719 15.1805 4.90px078 15.8625C5.43516 18.4852 6.60234 20.7352 8.41641 22.6406C8.79609 23.0414 9 23.3086 8.97891 23.3719C8.95781 23.4281 8.00156 25.1227 6.8625 27.1406C5.02031 30.382 4.78125 30.8391 4.78125 31.1063C4.78125 31.5422 5.02734 31.7813 5.47734 31.7813C5.65312 31.7742 6.82734 31.5633 8.08594 31.2961C9.76641 30.9445 10.3852 30.8391 10.4203 30.90px24C10.4484 30.9445 10.8492 32.0555 11.3203 33.3703C11.9391 35.107 12.2062 35.7891 12.3258 35.8734C12.5508 36.0563 13.0641 36.0422 13.268 35.8524C13.3523 35.768 14.4633 33.8695 15.7289 31.6336C16.9945 29.3977 18.0492 27.5695 18.0703 27.5695C18.0914 27.5695 19.1461 29.3977 20.4117 31.6336C21.6773 33.8695 22.7883 35.768 22.8797 35.8524C23.1117 36.0703 23.618 36.0563 23.843 35.8313C23.9625 35.7188 24.2648 34.9524 24.8133 33.3914C25.2563 32.1399 25.65 31.05 25.6922 30.9656C25.7695 30.818 25.7766 30.818 28.0547 31.2961C29.3133 31.5563 30.4875 31.7742 30.6633 31.7813C31.1133 31.7813 31.3594 31.5422 31.3594 31.1063C31.3594 30.832 31.1273 30.3891 29.2852 27.1406C28.1391 25.1297 27.1898 23.4352 27.1687 23.3789C27.1406 23.3086 27.3305 23.0555 27.7242 22.6406C29.5383 20.7352 30.7055 18.4852 31.2398 15.8625C31.3734 15.1805 31.3945 14.8711 31.3945 13.3594C31.3945 11.8547 31.3734 11.5383 31.2328 10.8563C30.7055 8.24063 29.5102 5.92032 27.7102 4.05704C26.6062 2.91094 25.5164 2.11641 24.0258 1.36407C22.943 0.822662 21.4172 0.316414 21.0656 0.379692C20.7141 0.442974 20.4961 0.717194 20.4961 1.08985C20.4961 1.55391 20.6719 1.69454 21.6422 2.00391C25.875 3.36094 28.8352 6.69376 29.7914 11.1797C29.9883 12.1078 29.9672 14.7516 29.7562 15.7078C28.6734 20.5664 25.0664 24.1172 20.2641 25.0664C19.0336 25.3125 17.107 25.3125 15.8766 25.0664C11.6016 24.2227 8.14922 21.2203 6.78516 17.1422C6.3 15.6867 6.22969 15.2016 6.22969 13.3594C6.22969 11.5172 6.3 11.032 6.78516 9.57657C8.01562 5.90px626 10.8703 3.13594 14.6039 1.97579C15.4547 1.7086 15.6445 1.54688 15.6445 1.08282C15.6445 0.843758 15.6023 0.738289 15.4617 0.590px63C15.1734 0.302349 14.857 0.30938 13.90px08 0.625786ZM10.8422 24.6375C12.368 25.6289 14.3508 26.3672 16.1156 26.5992C16.4602 26.6484 16.7414 26.7117 16.7484 26.7469C16.7695 26.8383 12.9797 33.4688 12.9305 33.4125C12.90px94 33.3844 12.593 32.5266 12.2344 31.5C11.4891 29.3836 11.4117 29.25 10.90px55 29.25C10.7297 29.25 9.77344 29.4258 8.7890px6 29.6297C7.80469 29.8406 6.9890px6 30.0024 6.98203 29.9953C6.96094 29.9813 10.2094 24.2578 10.2375 24.2578C10.2516 24.2578 10.5258 24.4266 10.8422 24.6375ZM27.5625 27.1406C28.4484 28.7016 29.1656 29.9883 29.1586 29.9953C29.1516 30.0024 28.3359 29.8406 27.3516 29.6297C26.3672 29.4258 25.4109 29.257 25.2352 29.25C24.7289 29.25 24.6516 29.3836 23.90px62 31.5C23.5477 32.5266 23.2312 33.3844 23.2102 33.4125C23.168 33.4617 19.3992 26.90px86 19.3781 26.7539C19.3781 26.7188 19.6594 26.6484 20.018 26.5992C21.8109 26.3602 23.9766 25.5445 25.3828 24.5813C25.6359 24.4055 25.8609 24.2719 25.8961 24.2789C25.9242 24.2859 26.6766 25.5727 27.5625 27.1406Z"
                                    fill="#E90px04F"
                                  ></path>
                                  <path
                                    d="M16.4883 2.88281C15.7359 3.00235 14.6742 3.30469 13.957 3.61407C12.5648 4.19766 11.5383 4.92188 10.4344 6.06797C9.02812 7.52344 8.13516 9.21094 7.69219 11.25C7.58672 11.7281 7.55859 12.143 7.55859 13.3594C7.55859 15.0047 7.62187 15.4617 8.02266 16.6852C8.54297 18.2742 9.3375 19.5398 10.6102 20.8195C12.1641 22.3734 13.8164 23.2734 15.9609 23.7375C16.8187 23.9273 19.3219 23.9273 20.1797 23.7375C22.3383 23.2664 23.9695 22.3734 25.5305 20.8195C27.0844 19.2586 27.9773 17.6273 28.4484 15.4688C28.6383 14.6109 28.6383 12.1078 28.4484 11.25C27.9773 9.09141 27.0844 7.46016 25.5305 5.89922C23.9977 4.36641 22.4367 3.50156 20.3273 3.00938C19.6312 2.84766 17.2266 2.77032 16.4883 2.88281ZM19.6172 4.4086C23.3438 5.02735 26.3883 8.07188 27.0281 11.8055C27.2672 13.190px6 27.1406 14.90px63 26.7047 16.207C25.9523 18.443 24.3492 20.3203 22.2117 21.4383C20.0812 22.5563 17.4516 22.7531 15.1453 21.9727C12.5508 21.0867 10.3219 18.8508 9.45 16.2633C8.83828 14.4422 8.83828 12.2766 9.45703 10.4414C9.86484 9.20391 10.7016 7.88203 11.6859 6.91172C13.8234 4.80938 16.6641 3.90px938 19.6172 4.4086Z"
                                    fill="#E90px04F"
                                  ></path>
                                  <path
                                    d="M17.7398 6.57428C17.5359 6.65866 17.4094 6.87662 16.6008 8.48678L15.6937 10.3079L13.90px78 10.5751C12.9305 10.7227 12.0094 10.8704 11.8687 10.90px55C11.5242 10.9969 11.3203 11.2641 11.3203 11.6227C11.3203 11.90px4 11.3625 11.9532 12.7758 13.3735L14.2383 14.836L13.9359 16.6501C13.5773 18.8368 13.5703 18.9282 13.8445 19.2024C14.2102 19.561 14.3719 19.5118 16.3336 18.4993L18.0773 17.5922L19.8141 18.4993C21.7688 19.5118 21.9305 19.561 22.2961 19.2024C22.5703 18.9282 22.5633 18.8368 22.2047 16.6501L21.90px23 14.836L23.3648 13.3735C24.7781 11.9532 24.8203 11.90px4 24.8203 11.6227C24.8203 11.2641 24.6164 10.9969 24.2719 10.90px55C24.1312 10.8704 23.2102 10.7157 22.2328 10.5751L20.4469 10.3079L19.5398 8.48678C18.7031 6.82037 18.6047 6.66569 18.3867 6.56725C18.0914 6.44772 18.0281 6.44772 17.7398 6.57428ZM18.7172 10.2305C19.118 11.0251 19.3922 11.4962 19.5117 11.5735C19.6172 11.6438 20.2078 11.7633 21.0023 11.8899C21.7336 12.0024 22.3664 12.1008 22.4227 12.1079C22.4719 12.1219 22.0781 12.5508 21.5437 13.0712C21.0023 13.5915 20.5312 14.0837 20.482 14.161C20.3555 14.379 20.3695 14.6813 20.6016 16.0243C20.7141 16.6993 20.7984 17.2688 20.7844 17.2758C20.7703 17.2899 20.2078 17.0157 19.5328 16.6641C18.7031 16.2422 18.225 16.0313 18.0703 16.0313C17.9156 16.0313 17.4375 16.2422 16.6078 16.6712C15.9328 17.0157 15.3703 17.2969 15.3562 17.2829C15.3422 17.2688 15.4266 16.6993 15.5391 16.0243C15.7711 14.6813 15.7852 14.386 15.6586 14.161C15.6094 14.0766 15.1312 13.5915 14.5969 13.0712C14.0484 12.5438 13.6617 12.1219 13.718 12.1079C13.7742 12.1008 14.407 12.0024 15.1383 11.8899C15.9328 11.7633 16.5234 11.6438 16.6289 11.5735C16.7484 11.4962 17.0227 11.0251 17.4234 10.2305C17.7609 9.55553 18.0492 9.00006 18.0703 9.00006C18.0914 9.00006 18.3797 9.55553 18.7172 10.2305Z"
                                    fill="#E90px04F"
                                  ></path>
                                </g>
                                <defs>
                                  <clipPath id="clip0_333_388">
                                    <rect
                                      width="36"
                                      height="36"
                                      fill="white"
                                    ></rect>
                                  </clipPath>
                                </defs>
                              </svg>
                              <h5>10+ Years Experience</h5>
                            </div>
                          </div>
                        </div>
                        <div className="col-6 position-relative">
                          <div className="about12 img-fluid">
                            <img
                              decoding="async"
                              // src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/about12.png"
                              src={img_team_2}
                              alt="About Image"
                            />
                          </div>
                          <div className="about13 img-fluid">
                            <img
                              decoding="async"
                              // src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/about13.png"
                              src={img_team_3}
                              alt="About Image"
                            />
                          </div>
                          <div className="sun-icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="66"
                              height="66"
                              viewBox="0 0 66 66"
                              fill="none"
                            >
                              <path
                                d="M46.0284 38.2122C49.1166 30.7159 45.5432 22.1354 38.0468 19.0472C30.5505 15.9589 21.97 19.5324 18.8818 27.0287C15.7935 34.5251 19.367 43.1056 26.8634 46.1938C34.3597 49.282 42.9402 45.7086 46.0284 38.2122Z"
                                fill="#E90px04F"
                              ></path>
                              <path
                                d="M32.4597 47.3301C30.5297 47.3351 28.6178 46.9577 26.8345 46.2197C25.0511 45.4816 23.4317 44.3975 22.0697 43.0301C20.3678 41.326 19.1103 39.2302 18.4076 36.9267C17.7049 34.6231 17.5786 32.1822 18.0397 29.8184C18.5008 27.4546 19.5353 25.2402 21.0522 23.3696C22.5691 21.499 24.5221 20.0295 26.7397 19.090px1C28.9729 18.1467 31.4048 17.7704 33.8187 17.9945C36.2326 18.2186 38.5536 19.0362 40.575 20.3746C42.5964 21.7129 44.2554 23.5304 45.4042 25.6652C46.5531 27.8 47.1562 30.1858 47.1597 32.6101C47.1558 35.5028 46.3003 38.3304 44.6997 40.74C43.0992 43.1497 40.8246 45.0348 38.1597 46.1601C36.3568 46.9265 34.4187 47.3243 32.4597 47.3301Z"
                                fill="#E90px04F"
                              ></path>
                              <path
                                d="M30.3697 65.46C30.2897 65.46 30.2197 62.75 30.2197 59.46C30.2197 56.17 30.2897 53.4 30.3697 53.4C30.5305 55.4158 30.5839 57.4386 30.5297 59.46C30.5821 61.4614 30.5287 63.4642 30.3697 65.46Z"
                                fill="#E90px04F"
                              ></path>
                              <path
                                d="M30.3702 65.48C30.3702 65.48 30.290px2 65.48 30.2502 63.69C30.2502 62.55 30.2002 61.03 30.2002 59.41C30.2002 57.79 30.2002 56.27 30.2502 55.12C30.2502 53.34 30.3402 53.34 30.3702 53.34C30.4002 53.34 30.4502 53.34 30.5002 55.12C30.5002 56.27 30.5002 57.79 30.5002 59.41C30.5002 61.03 30.5002 62.55 30.5002 63.69C30.4502 65.48 30.4002 65.48 30.3702 65.48ZM30.3702 53.38C30.3002 53.6 30.2302 55.9 30.2302 59.38C30.2302 62.86 30.3002 65.18 30.3702 65.38C30.4402 65.15 30.5102 62.85 30.5102 59.38C30.5102 55.91 30.4402 53.61 30.3702 53.38Z"
                                fill="#E90px04F"
                              ></path>
                              <path
                                d="M21.9103 49.94C21.9803 49.94 20.6003 52.51 18.8303 55.59C17.8058 57.4767 16.6843 59.3091 15.4703 61.08C15.4003 61.08 16.7803 58.51 18.5603 55.43C20.3403 52.35 21.8403 49.89 21.9103 49.94Z"
                                fill="#E90px04F"
                              ></path>
                              <path
                                d="M15.4797 61.1C15.4797 61.1 15.4097 61.1 16.3197 59.39C16.8997 58.32 17.6997 56.91 18.5597 55.39C19.4197 53.87 20.2397 52.52 20.8697 51.48C21.7597 50.01 21.8697 49.89 21.8697 49.89C21.8697 49.89 21.9397 49.89 21.0297 51.6C20.4397 52.67 19.6497 54.08 18.7897 55.6C17.2697 58.23 15.5697 61.06 15.4297 61.1H15.4797ZM21.8997 49.96C21.7197 50.14 20.4297 52.22 18.5697 55.44C16.7097 58.66 15.5697 60.81 15.4897 61.06C15.6697 60.88 16.9497 58.8 18.8097 55.58C20.6697 52.36 21.8297 50.21 21.8997 49.96Z"
                                fill="#E90px04F"
                              ></path>
                              <path
                                d="M13.2297 44.53C12.1569 45.5834 11.0107 46.5592 9.79968 47.45C8.65607 48.4255 7.44653 49.321 6.17969 50.13C7.25574 49.0803 8.4017 48.1048 9.60969 47.21C10.749 46.2292 11.9589 45.3334 13.2297 44.53Z"
                                fill="#E90px04F"
                              ></path>
                              <path
                                d="M6.18016 50.15C6.18016 50.15 6.18016 50.09 7.18016 49.23C7.83016 48.67 8.70016 47.96 9.65016 47.23C10.7993 46.2584 12.0083 45.36 13.2702 44.54C12.1894 45.5877 11.0438 46.5663 9.84016 47.47C8.90px016 48.21 8.00016 48.91 7.32016 49.41C6.97694 49.7092 6.59314 49.9583 6.18016 50.15ZM13.1802 44.55C11.9343 45.3719 10.7357 46.2633 9.590px16 47.22C8.39272 48.1208 7.24753 49.0891 6.16016 50.12C7.41388 49.3012 8.61615 48.4062 9.76016 47.44C10.9638 46.5426 12.1156 45.5777 13.2102 44.55H13.1802Z"
                                fill="#E90px04F"
                              ></path>
                              <path
                                d="M45.0296 59.5C44.8523 59.0169 44.7217 58.518 44.6396 58.01C44.4296 57.08 44.1296 55.81 43.7596 54.41C43.3896 53.01 42.9996 51.77 42.7596 50.86C42.5754 50.3811 42.4381 49.8854 42.3496 49.38C42.604 49.8275 42.8117 50.3 42.9696 50.79C43.2996 51.68 43.7196 52.93 44.0896 54.33C44.4596 55.73 44.7396 57.03 44.8996 57.96C44.9972 58.4673 45.0408 58.9835 45.0296 59.5Z"
                                fill="#E90px04F"
                              ></path>
                              <path
                                d="M45.0298 59.51C44.9798 59.51 44.9198 59.29 44.6298 58.01C44.4298 57.15 44.1198 55.84 43.7398 54.42C43.3598 53 42.9598 51.69 42.7398 50.86C42.3698 49.65 42.2898 49.39 42.3398 49.37C42.3898 49.35 42.3898 49.37 42.5598 49.75C42.7298 50.13 42.8198 50.38 42.9798 50.75C43.2098 51.36 43.6598 52.63 44.1098 54.3C44.5598 55.97 44.7998 57.3 44.90px98 57.93C45.0203 58.4359 45.0773 58.9521 45.0798 59.47L45.0298 59.51ZM42.3098 49.4C42.3098 49.51 42.4998 50.1 42.7298 50.84C42.9898 51.66 43.3798 52.94 43.7298 54.39C44.0798 55.84 44.4198 57.12 44.6198 57.98C44.7138 58.476 44.8339 58.9667 44.9798 59.45C44.963 58.9457 44.90px28 58.4439 44.7998 57.95C44.6898 57.31 44.4498 55.95 43.9998 54.32C43.5498 52.69 43.0998 51.38 42.8698 50.77C42.7198 50.2977 42.5291 49.8393 42.2998 49.4H42.3098Z"
                                fill="#E90px04F"
                              ></path>
                              <path
                                d="M59.90px97 48.93C58.3978 47.8144 56.9489 46.6159 55.5697 45.34C54.1202 44.1442 52.738 42.8689 51.4297 41.52C52.9416 42.6356 54.390px5 43.8341 55.7697 45.11C57.2163 46.3093 58.5982 47.5844 59.90px97 48.93Z"
                                fill="#E90px04F"
                              ></path>
                              <path
                                d="M59.90px03 48.95C59.7503 48.95 57.5603 47.1 55.5603 45.35C54.4303 44.35 53.3703 43.42 52.5603 42.7C51.3403 41.57 51.3703 41.53 51.390px3 41.51C52.898 42.6345 54.3466 43.8361 55.7303 45.11C56.8603 46.11 57.9203 47.04 58.7303 47.76C59.9503 48.89 59.9203 48.93 59.90px03 48.95ZM51.4503 41.54C51.5603 41.72 53.1303 43.19 55.5803 45.33C58.0303 47.47 59.690px3 48.83 59.890px3 48.91C59.7803 48.73 58.2203 47.27 55.7603 45.12C53.3003 42.97 51.6503 41.61 51.4503 41.54Z"
                                fill="#E90px04F"
                              ></path>
                              <path
                                d="M65.6098 34.4101C65.0141 34.3679 64.4224 34.281 63.8398 34.1501C62.7498 33.9701 61.2498 33.7401 59.5798 33.5501C57.90px98 33.3601 56.3898 33.2401 55.2898 33.1701C54.6935 33.166 54.0984 33.1158 53.5098 33.0201C54.1028 32.9383 54.7026 32.9182 55.2998 32.9601C56.4098 32.9601 57.9398 33.0501 59.6198 33.2401C61.0508 33.4002 62.4727 33.6338 63.8798 33.9401C64.4705 34.0395 65.05 34.1969 65.6098 34.4101Z"
                                fill="#E90px04F"
                              ></path>
                              <path
                                d="M65.5603 34.43C65.4303 34.43 65.0703 34.37 64.190px3 34.23L63.8403 34.1699C62.3503 33.9199 60.9203 33.7199 59.5803 33.5599C58.2403 33.3999 56.8003 33.29 55.290px3 33.19H54.9403C53.7303 33.11 53.490px3 33.09 53.5003 33.04C54.0968 32.9611 54.6994 32.9377 55.3003 32.97C56.0603 32.97 57.6403 33.03 59.6203 33.26C61.0552 33.4158 62.4807 33.6495 63.890px3 33.96C64.481 34.0594 65.0605 34.2169 65.6203 34.43C65.6203 34.43 65.6103 34.43 65.5603 34.43ZM53.5603 33.02C53.6603 33.02 54.2203 33.09 54.9603 33.14H55.3103C56.8303 33.23 58.3103 33.36 59.6003 33.51C60.890px3 33.66 62.3803 33.87 63.8603 34.12L64.2103 34.18C64.9203 34.3 65.4503 34.3799 65.590px3 34.3799C65.0301 34.1949 64.459 34.0446 63.8803 33.93C61.0575 33.331 58.1851 32.9962 55.3003 32.93C54.7123 32.9212 54.1243 32.9513 53.5403 33.02H53.5603Z"
                                fill="#E90px04F"
                              ></path>
                              <path
                                d="M65.6304 20.13C65.6304 20.21 62.4704 21.0601 58.5304 22.0201C54.590px4 22.9801 51.3804 23.690px1 51.3604 23.6101C51.3404 23.5301 54.5204 22.6801 58.4604 21.7201C62.4004 20.7601 65.6104 20.05 65.6304 20.13Z"
                                fill="#E90px04F"
                              ></path>
                              <path
                                d="M51.3896 23.61C51.3896 23.61 51.3896 23.53 53.4596 22.98C54.7996 22.62 56.5896 22.17 58.4596 21.7C60.3296 21.23 62.1596 20.82 63.4596 20.52C65.5796 20.05 65.5897 20.1 65.5997 20.13C65.5997 20.13 65.5997 20.2 63.5197 20.76C62.1797 21.12 60.3897 21.57 58.5197 22.03C56.6497 22.49 54.8196 22.92 53.4596 23.22C52.7774 23.3882 52.0863 23.5184 51.3896 23.61ZM65.5997 20.12C65.3097 20.12 62.5996 20.71 58.4596 21.71C54.3196 22.71 51.6496 23.44 51.3896 23.58C51.6796 23.58 54.3896 22.99 58.5296 21.98C62.6696 20.97 65.3397 20.27 65.5997 20.14V20.12Z"
                                fill="#E90px04F"
                              ></path>
                              <path
                                d="M49.0303 3.48999C49.1003 3.53999 47.5803 5.96 45.6403 8.91C43.7003 11.86 42.0303 14.2 42.0303 14.16C42.0303 14.12 43.4803 11.68 45.4303 8.73999C46.5422 6.93118 47.7437 5.179 49.0303 3.48999Z"
                                fill="#E90px04F"
                              ></path>
                              <path
                                d="M42.0298 14.17C42.0298 14.03 43.7598 11.27 45.4298 8.73999C46.3798 7.31999 47.2798 5.98999 47.9598 4.98999C49.0298 3.46999 49.0798 3.46999 49.1098 3.48999C49.1098 3.48999 49.1798 3.48999 48.1698 5.12999C47.5298 6.12999 46.6598 7.49999 45.7198 8.92999C44.7798 10.36 43.8798 11.68 43.1898 12.67C42.1598 14.05 42.0298 14.17 42.0298 14.17ZM49.0298 3.51999C48.8398 3.67999 47.4398 5.65999 45.3998 8.74999C43.3598 11.84 42.0798 13.9 42.0098 14.13C42.1998 13.97 43.5898 11.99 45.6298 8.89999C47.6698 5.80999 48.9498 3.74999 49.0298 3.51999Z"
                                fill="#E90px04F"
                              ></path>
                              <path
                                d="M32.58 0.0200195C32.6256 0.68590px9 32.6256 1.35413 32.58 2.02002C32.58 3.27002 32.58 5.02002 32.58 6.88002C32.58 8.74002 32.5801 10.49 32.6301 11.73C32.6814 12.3957 32.6814 13.0643 32.6301 13.73C32.5109 13.0697 32.444 12.4009 32.43 11.73C32.35 10.49 32.29 8.73002 32.29 6.87002C32.29 5.01002 32.35 3.25002 32.42 2.00002C32.4146 1.33658 32.4681 0.673971 32.58 0.0200195Z"
                                fill="#E90px04F"
                              ></path>
                              <path
                                d="M32.590px3 13.77C32.590px3 13.77 32.5403 13.77 32.490px3 13.22C32.490px3 12.85 32.4103 12.34 32.3803 11.75C32.3203 10.92 32.2403 9.17 32.2303 6.89C32.2203 4.61 32.3103 2.89 32.3603 2.02C32.3603 1.43 32.4403 0.919999 32.4803 0.549999C32.5303 0.0199993 32.5603 0 32.5703 0C32.5703 0 32.6303 0.19 32.5703 2C32.5703 3.17 32.5703 5 32.5703 6.86C32.5703 8.72 32.5703 10.4 32.6203 11.63V11.71C32.6203 13.56 32.6203 13.71 32.6203 13.71L32.590px3 13.77ZM32.590px3 0.0499992C32.4864 0.711987 32.4263 1.3801 32.4103 2.05C32.3603 2.89 32.2703 4.64 32.2703 6.92C32.2703 9.2 32.3603 10.92 32.4203 11.78C32.443 12.4495 32.5031 13.1172 32.6003 13.78C32.6003 13.61 32.6003 12.53 32.6003 11.78V11.71C32.6003 10.47 32.5503 8.78 32.5503 6.93C32.5503 5.08 32.5503 3.24 32.5503 2.07C32.590px3 1.3 32.6103 0.219999 32.5803 0.0499992H32.590px3Z"
                                fill="#E90px04F"
                              ></path>
                              <path
                                d="M20.1095 15.54C20.0395 15.54 18.4895 13.19 16.6495 10.19C14.8095 7.18996 13.3895 4.71996 13.4595 4.66996C13.5295 4.61996 15.0795 7.01996 16.9195 10.03C18.7595 13.04 20.1795 15.5 20.1095 15.54Z"
                                fill="#E90px04F"
                              ></path>
                              <path
                                d="M20.1099 15.6099C20.1099 15.6099 19.9399 15.4899 19.0299 14.0699C18.3799 13.0699 17.5299 11.6999 16.6399 10.2499C15.0699 7.66994 13.4099 4.85994 13.4499 4.71994C13.4899 4.57994 13.4499 4.71994 13.4499 4.71994C13.4499 4.71994 13.5099 4.71994 14.5299 6.25994C15.1899 7.25994 16.0299 8.62994 16.9199 10.0799C17.8099 11.5299 18.6299 12.90px99 19.2299 13.9499C20.1699 15.5799 20.1299 15.5999 20.1099 15.6199V15.6099ZM13.4799 4.74994C13.5399 4.97994 14.7399 7.07994 16.6699 10.2299C18.5999 13.3799 19.90px99 15.3999 20.0899 15.5699C20.0299 15.3299 18.8299 13.2299 16.90px99 10.0899C14.9899 6.94994 13.6599 4.85993 13.4799 4.69993V4.74994Z"
                                fill="#E90px04F"
                              ></path>
                              <path
                                d="M12.6596 21.87C12.1316 21.8555 11.6075 21.7748 11.0996 21.63C10.0996 21.43 8.82961 21.11 7.40961 20.69C5.98961 20.27 4.69961 19.82 3.78961 19.47C3.28675 19.3123 2.80359 19.0976 2.34961 18.83C2.86788 18.9331 3.37639 19.0803 3.86961 19.27C4.78961 19.56 6.06961 19.97 7.48961 20.39C8.90px961 20.81 10.2096 21.16 11.1496 21.39C11.665 21.5092 12.17 21.6697 12.6596 21.87Z"
                                fill="#E90px04F"
                              ></path>
                              <path
                                d="M12.6101 21.9H12.2301C11.9401 21.9 11.5501 21.78 11.1001 21.68C10.4501 21.55 9.1001 21.24 7.4001 20.74C5.7001 20.24 4.4001 19.74 3.790px1 19.53L2.7201 19.09C2.3201 18.91 2.3301 18.89 2.3301 18.87C2.3301 18.85 2.55009 18.87 3.87009 19.29C4.61009 19.53 6.0001 19.97 7.5001 20.41C9.0001 20.85 10.1001 21.16 11.1501 21.41C12.490px1 21.77 12.690px1 21.84 12.6801 21.89C12.6801 21.89 12.6701 21.9 12.6101 21.9ZM2.37009 18.84C2.83045 19.0824 3.30848 19.2896 3.80009 19.46C4.42009 19.7 5.7001 20.17 7.4101 20.67C9.1201 21.17 10.4601 21.48 11.1001 21.61C11.5966 21.7326 12.1012 21.8195 12.6101 21.87C12.1251 21.6966 11.631 21.5497 11.1301 21.43C10.0701 21.14 8.8401 20.81 7.4701 20.43C6.1001 20.05 4.5801 19.55 3.8401 19.31C3.2801 19.1 2.50009 18.85 2.37009 18.84Z"
                                fill="#E90px04F"
                              ></path>
                              <path
                                d="M9.40976 33.15C7.86193 33.4586 6.29504 33.6624 4.71976 33.76C3.15763 33.9589 1.58451 34.0591 0.00976562 34.06C1.55414 33.7509 3.11775 33.5471 4.68977 33.45C6.25522 33.2508 7.83168 33.1506 9.40976 33.15Z"
                                fill="#E90px04F"
                              ></path>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <!-- Content three --> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      </div>
      {/* ABout us section end */}



{/* tabs */}
<section>
<Box sx={{ width: '100%', typography: 'body1',color:"#fff" }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', color:"light",marginTop:"20px" }}>
          <TabList onChange={handleChange} aria-label="lab API tabs example" centered>
            <Tab className="text-light" label="Exceptional Service" value="1" />
            <Tab className="text-light" label="About WEB DESIGNING" value="2" />
            <Tab className="text-light" label="About SEO" value="3"/>
          </TabList>
        </Box>
        <TabPanel value="1">
        <div className="container mt-5">
        <div className="row">
          <div className="col-md-6 col-sm-6">
            <span><b>Exceptional Service
            </b></span>
            <h1><b>An Honest And Results Driven Creative Agency
            </b></h1>
            <h5><b>Focus Your Time And Efforts On Running Your Business And Leave The Marketing On Us
            </b></h5>
            <br />
            <p className="text-light">
              Top Notch Media Works is the best Branding Agency in Maharashtra. We design your brand, not as a profession it’s our passion. We do media planning and strategy for your business, providing best creative as well as marketing solutions for every business challenges, We provide Strategic planning, Digital media &  Print media to move your business next level. We have the perfect solution to your business issues.

            </p>
          </div>
          <div className="col-lg-6 col-sm-6 col-xs-6">
          <img
                              decoding="async"
                              // src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/about13.png"
                              src={shubham_2}
                              alt="About Image"
                            />
          </div>
        </div>
      </div>
        </TabPanel>
        <TabPanel value="2">
<div className="container" style={{backgroundColor:'#201f2d'}}>
  <div className="row">
    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
      <img src="https://d33wubrfki0l68.cloudfront.net/4f28ca45dc6ad1abfb5fa33666be2f669409d479/52cb6/native/assets/img/crossdevice.svg" alt="" />
    </div>
    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 mt-5">
      <h3>WEB DESIGNING</h3>
      <p className="mt-3 text-light">We at Top Notch Media Works help you design your own website of all the types ranging from small to medium businesses, also including e-commerce website. 
Web designing is the art of creation of various websites or pages which helps to represent a company’s brand, services or information which also ensures a user-friendly experience.</p>
    </div>
  </div>

</div>

        </TabPanel>
        <TabPanel value="3">
<div className="container">
  <div className="row">
    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
      <img src={chart} alt="" />
    </div>
    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 mt-5">
      <h3>GOOGLE PAGE MANAGEMENT</h3>
      <p className="text-light mt-3">Social media marketing plays an important role in helping your business or content reach wide areas and more number of audiences, also giving them the knowledge about your product or what you really are. Google is the best form of social media which is a search engine technology, and is publicly accessible offered by web servers. It has data in the form of text, images, videos etc. Whatever information people need they first search it on Google, and that’s why it is the most preferred social platform. Our professional team offers clients with the best company websites and online profiles that will draw attention and help you reach out to your targeted audiences around the world. 
</p>
    </div>
  </div>
</div>


        </TabPanel>
      </TabContext>
    </Box>
</section>


{/* gallary */}
{/* <section>
  <Grid Container>
    <Grid item xs={10} md={4}>
<ImageList
      sx={{ width: 430, height: 450 }}
      variant="quilted"
      cols={4}
      rowHeight={121}
    >
      {itemData.map((item) => (
        <ImageListItem key={item.img} cols={item.cols || 1} rows={item.rows || 1}>
          <img
            {...srcset(item.img, 121, item.rows, item.cols)}
            alt={item.title}
            loading="lazy"
          />
        </ImageListItem>
      ))}
    </ImageList>
    </Grid>
    </Grid>
</section> */}

      {/* main section */}
   

      <div className="container">
        <div className="row">
          <h1><b>An Effective Brand Strategy Gives You A Major Edge In Increasingly Competitive Markets.
          </b></h1>
          <br />
          <p className="text-light mt-3">We have passionate and creative designers who make us the best Branding Agency in Maharashtra.
            We love to design we live for it, we make designs with feelings and emotions. We make designs which express you. Our process involves marketing of products or services using digital technologies, mainly on the Internet, but also includes mobile phones, display advertising, and other digital media.

          </p>
          <section
            class="elementor-section elementor-top-section elementor-element elementor-element-3452cc0 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="3452cc0"
            data-element_type="section"
          >
            <div class="elementor-container elementor-column-gap-default">
              <div
                class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ef94e54"
                data-id="ef94e54"
                data-element_type="column"
              >
                <div class="elementor-widget-wrap elementor-element-populated">
                  <div
                    class="elementor-element elementor-element-2ec5233 elementor-widget elementor-widget-spinner_services"
                    data-id="2ec5233"
                    data-element_type="widget"
                    data-widget_type="spinner_services.default"
                  >
                    <div class="elementor-widget-container">
                      <script></script>

                      <div class="service3-section">
                        <div class="row justify-content-center g-4">
                          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-10">
                            <div
                              class="service-item3 wow fadeInUp"
                              data-wow-duration="1.5s"
                              data-wow-delay=".2s"
                            >
                              <div class="icon">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="50"
                                  height="50"
                                  viewBox="0 0 50 50"
                                  fill="none"
                                >
                                  <path
                                    d="M9.54102 0.15625C4.90234 0.996094 1.15234 4.6875 0.205078 9.3457C0 10.3125 0 10.5859 0 25C0 39.4141 0 39.6875 0.205078 40.6543C1.04492 44.7754 4.00391 48.1055 8.01758 49.4531C9.6582 50 9.58984 50 20.6836 50H30.8887L31.3086 49.7559C32.5195 49.043 32.5586 47.1094 31.377 46.3672L31.0059 46.1426L20.8984 46.0938C9.43359 46.0352 10.1465 46.084 8.34961 45.2148C6.66992 44.3945 5.60547 43.3301 4.78516 41.6504C3.89648 39.8145 3.95508 41.0254 3.95508 25C3.95508 8.97461 3.89648 10.1855 4.78516 8.34961C5.60547 6.66992 6.66992 5.60547 8.34961 4.78516C10.1855 3.89648 8.96484 3.95508 25.0488 3.95508H39.209L40.0781 4.17969C40.5469 4.29688 41.3184 4.58984 41.7871 4.83398C43.3789 5.6543 44.4336 6.73828 45.2148 8.34961C46.084 10.1465 46.0352 9.41406 46.0938 21.0156L46.1426 31.2305L46.4453 31.6113C47.2949 32.6758 48.7988 32.6758 49.6484 31.6113L49.9512 31.2305L49.9805 20.791C50 10.5566 50 10.3223 49.8047 9.3457C48.8477 4.6582 45.0781 0.966797 40.3906 0.146484C39.6387 0.0195312 37.6465 0 24.9121 0.00976562C12.7637 0.0195312 10.1758 0.0390625 9.54102 0.15625Z"
                                    fill="#A044FF"
                                  ></path>
                                  <path
                                    d="M11.0539 9.92187C10.1457 10.3809 9.71603 11.1719 9.78439 12.3047C9.83322 13.1543 10.1945 13.7793 10.8781 14.209C11.3176 14.4727 11.4348 14.502 12.2063 14.502C12.9777 14.502 13.0949 14.4727 13.5344 14.209C13.8274 14.0234 14.1203 13.7305 14.3059 13.4375C14.5695 12.998 14.5988 12.8809 14.5988 12.1094C14.5988 11.3379 14.5695 11.2207 14.3059 10.7812C13.8567 10.0586 13.2414 9.72656 12.3137 9.6875C11.6692 9.6582 11.5031 9.6875 11.0539 9.92187Z"
                                    fill="#A044FF"
                                  ></path>
                                  <path
                                    d="M19.3652 10.6055C18.7598 10.9668 18.457 11.5332 18.457 12.3047C18.457 13.0859 18.7598 13.6523 19.375 14.0137L19.7949 14.2578H29.3457H38.8965L39.3164 14.0137C39.9316 13.6523 40.2344 13.0859 40.2344 12.3047C40.2344 11.5234 39.9316 10.957 39.3164 10.5957L38.8965 10.3516H29.3359H19.7754L19.3652 10.6055Z"
                                    fill="#A044FF"
                                  ></path>
                                  <path
                                    d="M10.6738 18.418C10.0684 18.7793 9.76562 19.3457 9.76562 20.1172C9.76562 20.8984 10.0684 21.4648 10.6836 21.8262L11.1035 22.0703H25H38.8965L39.3164 21.8262C39.9316 21.4648 40.2344 20.8984 40.2344 20.1172C40.2344 19.3359 39.9316 18.7695 39.3164 18.4082L38.8965 18.1641H24.9902H11.084L10.6738 18.418Z"
                                    fill="#A044FF"
                                  ></path>
                                  <path
                                    d="M10.6738 26.2305C10.0684 26.5918 9.76562 27.1582 9.76562 27.9297C9.76562 28.7109 10.0684 29.2773 10.6836 29.6387L11.1035 29.8828H15.2344H19.3652L19.7852 29.6387C20.4004 29.2773 20.7031 28.7109 20.7031 27.9297C20.7031 27.1484 20.4004 26.582 19.7852 26.2207L19.3652 25.9766H15.2246H11.084L10.6738 26.2305Z"
                                    fill="#A044FF"
                                  ></path>
                                  <path
                                    d="M26.8848 26.2305C26.3086 26.5723 25.9766 27.1582 25.9766 27.8418C25.9766 28.6426 27.207 34.6191 27.6074 35.7715C28.1152 37.2363 28.8086 38.5352 29.7656 39.7949C30.3613 40.5762 37.4512 47.7246 38.3594 48.4473C39.6875 49.5117 41.0938 50 42.8711 50C44.6094 50 46.0156 49.5312 47.334 48.4961C49.0527 47.1484 50 45.1562 50 42.8711C50 41.0938 49.5117 39.6875 48.4473 38.3594C47.5195 37.1973 40.293 30.1074 39.4043 29.4824C38.3301 28.7207 36.9531 28.0078 35.7812 27.6074C34.6094 27.1973 28.6328 25.9766 27.832 25.9766C27.4316 25.9766 27.1875 26.0449 26.8848 26.2305ZM32.3535 30.8594C34.5703 31.3184 35.7031 31.7871 37.1094 32.8223C38.0469 33.5156 45.4395 40.9668 45.7129 41.5039C45.9082 41.875 45.9473 42.0898 45.9473 42.8711C45.9473 43.6523 45.9082 43.8672 45.7227 44.2188C45.1074 45.3711 44.1016 45.9961 42.8711 45.9961C41.5332 45.9961 41.5234 45.9863 37.002 41.4453C34.8242 39.248 32.8809 37.2266 32.6953 36.9629C31.7578 35.625 31.2988 34.4727 30.8594 32.3535C30.7031 31.5527 30.5469 30.8105 30.5176 30.6836C30.4688 30.498 30.498 30.4688 30.6836 30.5176C30.8105 30.5469 31.5527 30.7031 32.3535 30.8594Z"
                                    fill="#A044FF"
                                  ></path>
                                </svg>
                              </div>
                              <div class="content">
                                <p class="para">
                                  The marketing practice of creating a name, symbol or design that identifies and differentiates a product from other products.
                                </p>
                              </div>

                            </div>
                          </div>
                          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-10">
                            <div
                              class="service-item3 wow fadeInUp"
                              data-wow-duration="1.5s"
                              data-wow-delay=".2s"
                            >
                              <div class="icon">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="50"
                                  height="50"
                                  viewBox="0 0 50 50"
                                  fill="none"
                                >
                                  <g clipPath="url(#clip0_384_5457)">
                                    <path
                                      d="M0.644531 0.185555C0.498047 0.283211 0.283203 0.498055 0.185547 0.644539C0.00976562 0.908211 0 1.16212 0 4.39454C0 7.62696 0.00976562 7.88087 0.185547 8.14454C0.283203 8.29102 0.498047 8.50587 0.644531 8.60352C0.908203 8.7793 1.16211 8.78907 4.39453 8.78907C7.62695 8.78907 7.88086 8.7793 8.14453 8.60352C8.68164 8.2422 8.78906 7.95899 8.78906 6.85548V5.85938L11.748 5.86915C14.5508 5.86915 14.6875 5.87891 14.4531 6.03516C10.8008 8.53516 8.10547 12.1387 6.79688 16.2988C6.50391 17.2266 6.10352 19.1797 6.00586 20.1367C5.9375 20.8008 5.9375 20.8008 5.53711 20.9863C4.48242 21.4551 3.56445 22.5 3.22266 23.6035C2.49023 25.9863 3.70117 28.4082 6.03516 29.209C6.76758 29.4629 8.07617 29.4629 8.80859 29.209C10.1562 28.75 11.1719 27.7344 11.6309 26.3965C11.8848 25.6543 11.8848 24.4531 11.6211 23.6035C11.2793 22.5098 10.2344 21.3281 9.29688 20.9766L8.97461 20.8594L9.04297 20.3125C9.25781 18.4473 9.79492 16.6992 10.6934 14.8926C11.5332 13.2227 12.4023 12.0117 13.7695 10.6445C15.4785 8.93555 17.3145 7.73438 19.4434 6.94337C21.0059 6.35743 20.9863 6.35743 21.377 6.94337C21.8164 7.5879 22.3633 8.04688 23.1445 8.42774C23.7598 8.73048 23.8281 8.74024 25 8.74024C26.1719 8.74024 26.2402 8.73048 26.8555 8.42774C27.6367 8.04688 28.1836 7.5879 28.623 6.94337C29.0137 6.35743 28.9941 6.35743 30.5566 6.94337C32.6855 7.73438 34.5215 8.93555 36.2305 10.6445C37.5977 12.0117 38.4668 13.2227 39.3066 14.8926C40.2051 16.6992 40.7422 18.4473 40.957 20.3125L41.0254 20.8594L40.7031 20.9766C39.7656 21.3281 38.7207 22.5098 38.3789 23.6035C37.6465 25.9863 38.8574 28.4082 41.1914 29.209C42.2461 29.5703 43.8867 29.4141 44.7949 28.8477C46.2207 27.9492 46.9727 26.6504 46.9727 25.0391C46.9727 23.2324 46.0156 21.6895 44.4629 20.9863C44.0625 20.8008 44.0625 20.8008 43.9941 20.1367C43.9551 19.7754 43.8184 18.9356 43.6914 18.2617C42.7441 13.4863 39.873 9.06251 35.9668 6.3672L35.2148 5.85938H38.2129H41.2109V6.85548C41.2109 7.95899 41.3184 8.2422 41.8555 8.60352C42.1191 8.7793 42.373 8.78907 45.6055 8.78907C48.8379 8.78907 49.0918 8.7793 49.3555 8.60352C49.502 8.50587 49.7168 8.29102 49.8145 8.14454C49.9902 7.88087 50 7.62696 50 4.39454C50 1.16212 49.9902 0.908211 49.8145 0.644539C49.7168 0.498055 49.502 0.283211 49.3555 0.185555C49.0918 0.00977325 48.8379 7.62939e-06 45.6055 7.62939e-06C42.373 7.62939e-06 42.1191 0.00977325 41.8555 0.185555C41.3184 0.546883 41.2109 0.830086 41.2109 1.92384V2.9297H35.2051H29.209L29.0234 2.50977C28.7207 1.85548 28.2617 1.29884 27.627 0.830086C25.4102 -0.800774 22.0996 0.0390701 20.9766 2.50977L20.791 2.9297H14.7949H8.78906V1.92384C8.78906 0.830086 8.68164 0.546883 8.14453 0.185555C7.88086 0.00977325 7.62695 7.62939e-06 4.39453 7.62939e-06C1.16211 7.62939e-06 0.908203 0.00977325 0.644531 0.185555ZM5.85938 4.39454V5.85938H4.39453H2.92969V4.39454V2.9297H4.39453H5.85938V4.39454ZM47.0703 4.39454V5.85938H45.6055H44.1406V4.39454V2.9297H45.6055H47.0703V4.39454ZM25.7227 3.2129C26.1426 3.4961 26.3672 3.89649 26.3672 4.39454C26.3672 4.89259 26.1426 5.29298 25.7227 5.57618C25.5469 5.6836 25.2637 5.76173 25 5.76173C24.2188 5.76173 23.6328 5.17579 23.6328 4.39454C23.6328 3.61329 24.2188 3.02735 25 3.02735C25.2637 3.02735 25.5469 3.10548 25.7227 3.2129ZM8.14453 23.8184C8.56445 24.1016 8.78906 24.502 8.78906 25C8.78906 25.7813 8.20312 26.3672 7.42188 26.3672C6.64062 26.3672 6.05469 25.7813 6.05469 25C6.05469 24.2188 6.64062 23.6328 7.42188 23.6328C7.68555 23.6328 7.96875 23.7109 8.14453 23.8184ZM43.3008 23.8184C43.7207 24.1016 43.9453 24.502 43.9453 25C43.9453 25.7813 43.3594 26.3672 42.5781 26.3672C41.7969 26.3672 41.2109 25.7813 41.2109 25C41.2109 24.7363 41.2891 24.4531 41.3965 24.2774C41.6797 23.8574 42.0801 23.6328 42.5781 23.6328C42.8418 23.6328 43.125 23.7109 43.3008 23.8184Z"
                                      fill="#A044FF"
                                    ></path>
                                    <path
                                      d="M24.2577 11.9629C24.0234 12.0898 22.6269 14.1113 18.0468 20.9766C14.7948 25.8496 12.0605 29.9805 11.9726 30.1465C11.7968 30.4883 11.7675 31.1035 11.9042 31.4746C11.953 31.6016 12.2753 32.0117 12.6171 32.3828C15.0683 35.0586 16.748 38.4082 17.3339 41.7969L17.4902 42.6953L17.0995 43.0273C16.162 43.8379 15.205 45.498 14.9023 46.8457C14.8144 47.2363 14.746 47.8906 14.746 48.3105C14.746 49.1504 14.8925 49.4824 15.3905 49.8145C15.664 49.9902 16.0253 50 24.9999 50C33.9745 50 34.3359 49.9902 34.6093 49.8145C35.1074 49.4824 35.2538 49.1504 35.2538 48.3105C35.2538 47.8906 35.1855 47.2363 35.0976 46.8457C34.7949 45.498 33.8378 43.8379 32.9003 43.0273L32.5097 42.6953L32.666 41.7969C33.2519 38.4082 34.9316 35.0586 37.3828 32.3828C37.7246 32.0117 38.0468 31.6016 38.0956 31.4746C38.2324 31.1133 38.2031 30.4883 38.0273 30.1562C37.705 29.5312 26.1913 12.3438 25.9374 12.1191C25.6054 11.8066 24.7167 11.7285 24.2577 11.9629ZM23.5351 22.4609V26.6504L23.1249 26.8359C22.0605 27.3145 21.1425 28.3496 20.8007 29.4629C20.0683 31.8457 21.2792 34.2676 23.6132 35.0684C24.6679 35.4297 26.3085 35.2734 27.2167 34.707C28.6425 33.8086 29.3945 32.5098 29.3945 30.8984C29.3945 29.082 28.4374 27.5488 26.8847 26.8359L26.4648 26.6504V22.4316V18.2129L30.6152 24.4434L34.7753 30.6738L34.1113 31.5039C32.0702 34.0723 30.5663 37.1973 29.8827 40.293L29.6581 41.2793L29.3066 41.2012C28.8476 41.0938 21.1523 41.0938 20.6933 41.2012L20.3417 41.2793L20.1171 40.293C19.4335 37.1973 17.9296 34.0723 15.8886 31.5039L15.2245 30.6738L19.3554 24.4727C21.6308 21.0547 23.496 18.2617 23.5156 18.2617C23.5253 18.2617 23.5351 20.1465 23.5351 22.4609ZM25.7226 29.6777C26.1425 29.9609 26.3671 30.3613 26.3671 30.8594C26.3671 31.6406 25.7812 32.2266 24.9999 32.2266C24.5019 32.2266 24.1015 32.002 23.8183 31.582C23.4277 30.9863 23.6425 30.0977 24.2773 29.6777C24.6484 29.4336 25.3515 29.4336 25.7226 29.6777ZM29.1894 44.3262C30.2929 44.707 31.2011 45.4883 31.7382 46.5039L32.041 47.0703H24.9999H17.9589L18.2616 46.5039C18.9355 45.2246 20.1659 44.3555 21.5917 44.1406C21.8847 44.0918 23.5741 44.0723 25.3417 44.082C28.4179 44.1016 28.5937 44.1113 29.1894 44.3262Z"
                                      fill="#A044FF"
                                    ></path>
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_384_5457">
                                      <rect
                                        width="50"
                                        height="50"
                                        fill="white"
                                      ></rect>
                                    </clipPath>
                                  </defs>
                                </svg>
                              </div>
                              <div class="content">

                                <p class="para">
                                  Mediahub will offer media strategy, communication planning, media planning and buy across all touch-points, both on and offline. Media hub will help your business to come up.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* <div className="row text-center">
            <img src="https://scontent.fbom6-1.fna.fbcdn.net/v/t39.30808-6/290773485_2114717422023281_3951739351861439352_n.png?_nc_cat=111&ccb=1-7&_nc_sid=730e14&_nc_ohc=2XWZ2D3Zpz4AX9cGsaz&_nc_ht=scontent.fbom6-1.fna&oh=00_AfDmeOY7DlWD2gvTmbnKIcpUkkeXEtmJFPOW1OadJQw0_g&oe=63ACAE0E" alt="" style={{ height: "600px", width: '900px' }} className="mx-3" />
          </div> */}
        </div>
      </div >

<section>
      <div className="middle-block">
  <div className="container-hexa">
    <div className="middle-background">
      <h2>OUR PROJECTS</h2>
      <div className="container-info">
        <ul id="hexGrid">
          <li className="hex">
            <div className="hexIn">
              <a
                className="hexLink"
                href="#"
                target="_blank"
              >
                <img
                  // src="https://d33wubrfki0l68.cloudfront.net/c6f0a511c76a3d08ef16b6c10520b319221ba637/38f36/community/assets/img/nikebyyou.jpg"
                  src={tata_new}
                  alt=""
                />
                <div className="desc">
                  <div className="hexDesc">Tata Motors</div>
                  {/* <div className="hexDesc author">Aurangabad</div> */}
                </div>
                <img
                  src="https://d33wubrfki0l68.cloudfront.net/2cf7ea43dc427e8092ab92837b0f2a3d006ed448/4875d/assets/img/hoverframe.svg"
                  // src={hridayam}
                  className="hoverFrame"
                />
                <img
                  src="https://d33wubrfki0l68.cloudfront.net/0c24d63303fd772a293a5e229bd0f00aef1cd95a/e72cc/assets/img/defaultframe.svg"
                  // src={hridayam}
                  className="defaultFrame"
                />
              </a>
            </div>
          </li>
          <li className="hex">
            <div className="hexIn">
              <a
                className="hexLink"
                href="#"
                target="_blank"
              >
                <img
                  // src="https://d33wubrfki0l68.cloudfront.net/3c3f7a720e33543cf781e78a211ebcc15f47562e/c3643/community/assets/img/roomcollege.jpg"
                  src={mahindra}
                  alt="College Room Planner"
                />
                <div className="desc">
                  <div className="hexDesc">Mahindra</div>
                  {/* <div className="hexDesc author">A TATA Product</div> */}
                </div>
                <img
                  src="https://d33wubrfki0l68.cloudfront.net/2cf7ea43dc427e8092ab92837b0f2a3d006ed448/4875d/assets/img/hoverframe.svg"
                  // src={rpdaga}
                  className="hoverFrame"
                />
                <img
                  src="https://d33wubrfki0l68.cloudfront.net/0c24d63303fd772a293a5e229bd0f00aef1cd95a/e72cc/assets/img/defaultframe.svg"
                  // src={saisuvidha}
                  className="defaultFrame"
                />
              </a>
            </div>
          </li>
          <li className="hex">
            <div className="hexIn">
              <a
                className="hexLink"
                href="#"
                target="_blank"
              >
                <img
                  // src="https://d33wubrfki0l68.cloudfront.net/88f90b9af09d8fd2e358bcf8b75dd50a011c529b/3d9f5/community/assets/img/ibmautoship.jpg"
                  src={usha}
                  alt="Mayflower Autonomous Ship"
                />
                <div className="desc">
                  <div className="hexDesc">USHA</div>
                  {/* <div className="hexDesc author"> building wealth through a variety of methods</div> */}
                </div>
                <img
                  src="https://d33wubrfki0l68.cloudfront.net/2cf7ea43dc427e8092ab92837b0f2a3d006ed448/4875d/assets/img/hoverframe.svg"
                  // src={plus}
                  className="hoverFrame"
                />
                <img
                  src="https://d33wubrfki0l68.cloudfront.net/0c24d63303fd772a293a5e229bd0f00aef1cd95a/e72cc/assets/img/defaultframe.svg"
                  // src={naresh}
                  className="defaultFrame"
                />
              </a>
            </div>
          </li>
          <li className="hex">
            <div className="hexIn">
              <a
                className="hexLink"
                href="#"
                target="_blank"
              >
                <img
                  // src="https://d33wubrfki0l68.cloudfront.net/398b1ebd2693249876d4a73480f5b12244de1886/713a7/games/assets/img/minecraft_classic.png"
                  src={kidzee}
                  alt="Minecraft Classic"
                />
                <div className="desc">
                  <div className="hexDesc">Kidzee school</div>
                  {/* <div className="hexDesc author">A Best Jewellery shop in Parbhani</div> */}
                </div>
                <img
                  src="https://d33wubrfki0l68.cloudfront.net/2cf7ea43dc427e8092ab92837b0f2a3d006ed448/4875d/assets/img/hoverframe.svg"
                  className="hoverFrame"
                />
                <img
                  src="https://d33wubrfki0l68.cloudfront.net/0c24d63303fd772a293a5e229bd0f00aef1cd95a/e72cc/assets/img/defaultframe.svg"
                  className="defaultFrame"
                />
              </a>
            </div>
          </li>
          <li className="hex">
            <div className="hexIn">
              <a
                className="hexLink"
                href="http://varadinfra.com/"
                target="_blank"
              >
                <img
                  // src="https://d33wubrfki0l68.cloudfront.net/ce06567ea287d765f5716369a9c721f28ce95c35/77bf0/community/assets/img/redarrows.jpg"
                  src={varad_logo}
                  alt="Red Arrows - British Royal Airforce"
                />
                <div className="desc">
                  <div className="hexDesc">Varad Infra</div>
                  <div className="hexDesc author">Make Your Dream
House With Our Professionals </div>
                </div>
                <img
                  src="https://d33wubrfki0l68.cloudfront.net/2cf7ea43dc427e8092ab92837b0f2a3d006ed448/4875d/assets/img/hoverframe.svg"
                  className="hoverFrame"
                />
                <img
                  src="https://d33wubrfki0l68.cloudfront.net/0c24d63303fd772a293a5e229bd0f00aef1cd95a/e72cc/assets/img/defaultframe.svg"
                  className="defaultFrame"
                />
              </a>
            </div>
          </li>
          <li className="hex">
            <div className="hexIn">
              <a
                className="hexLink"
                href="https://saisuvidharestaurant.com/"
                target="_blank"
              >
                <img
                  // src="https://d33wubrfki0l68.cloudfront.net/ddafca54df103fd07572c355f85f24d3d8a1a72e/d29a7/community/assets/img/sharepoint-spaces.jpg"
                  src={saisuvidha}
                  alt="SharePoint Spaces"
                />
                <div className="desc">
                  <div className="hexDesc">Sai Suvidha Restaurent</div>
                  <div className="hexDesc author"> Veg Restaurant in Waluj MIDC,Aurangabad</div>
                </div>
                <img
                  src="https://d33wubrfki0l68.cloudfront.net/2cf7ea43dc427e8092ab92837b0f2a3d006ed448/4875d/assets/img/hoverframe.svg"
                  className="hoverFrame"
                />
                <img
                  src="https://d33wubrfki0l68.cloudfront.net/0c24d63303fd772a293a5e229bd0f00aef1cd95a/e72cc/assets/img/defaultframe.svg"
                  className="defaultFrame"
                />
              </a>
            </div>
          </li>
          <li className="hex">
            <div className="hexIn">
              <a
                className="hexLink"
                href="https://plushealthcaresolutions.in/"
                target="_blank"
              >
                <img
                  // src="https://d33wubrfki0l68.cloudfront.net/518a4e1de9fa16c00f5a898fe33efac202346449/eadbc/community/assets/img/masters.jpg"
                  src={plus_logo}
                  alt="US Masters"
                />
                <div className="desc">
                  <div className="hexDesc">Plus Healthcare</div>
                  <div className="hexDesc author">Healthcare Consultancy Firms in Maharashtra</div>
                </div>
                <img
                  src="https://d33wubrfki0l68.cloudfront.net/2cf7ea43dc427e8092ab92837b0f2a3d006ed448/4875d/assets/img/hoverframe.svg"
                  className="hoverFrame"
                />
                <img
                  src="https://d33wubrfki0l68.cloudfront.net/0c24d63303fd772a293a5e229bd0f00aef1cd95a/e72cc/assets/img/defaultframe.svg"
                  className="defaultFrame"
                />
              </a>
            </div>
          </li>
          <li className="hex">
            <div className="hexIn">
              <a
                className="hexLink"
                href="https://shreejewellerspbn.com/"
                target="_blank"
              >
                <img
                  // src="https://d33wubrfki0l68.cloudfront.net/ce06567ea287d765f5716369a9c721f28ce95c35/77bf0/community/assets/img/redarrows.jpg"
                  src={logo_shree}
                  alt="Red Arrows - British Royal Airforce"
                />
                <div className="desc">
                  <div className="hexDesc">SHREE JEWELLERS</div>
                  <div className="hexDesc author">A Best Jewellery shop in Parbhani </div>
                </div>
                <img
                  src="https://d33wubrfki0l68.cloudfront.net/2cf7ea43dc427e8092ab92837b0f2a3d006ed448/4875d/assets/img/hoverframe.svg"
                  className="hoverFrame"
                />
                <img
                  src="https://d33wubrfki0l68.cloudfront.net/0c24d63303fd772a293a5e229bd0f00aef1cd95a/e72cc/assets/img/defaultframe.svg"
                  className="defaultFrame"
                />
              </a>
            </div>
          </li>
          <li className="hex">
            <div className="hexIn">
              <a
                className="hexLink"
                href="https://muthamotors.com/"
                target="_blank"
              >
                <img
                  // src="https://d33wubrfki0l68.cloudfront.net/ddafca54df103fd07572c355f85f24d3d8a1a72e/d29a7/community/assets/img/sharepoint-spaces.jpg"
                  src={mutha_logo}
                  alt="SharePoint Spaces"
                />
                <div className="desc">
                  <div className="hexDesc">Mutha Motors</div>
                  <div className="hexDesc author"> We Belive in Humanity</div>
                </div>
                <img
                  src="https://d33wubrfki0l68.cloudfront.net/2cf7ea43dc427e8092ab92837b0f2a3d006ed448/4875d/assets/img/hoverframe.svg"
                  className="hoverFrame"
                />
                <img
                  src="https://d33wubrfki0l68.cloudfront.net/0c24d63303fd772a293a5e229bd0f00aef1cd95a/e72cc/assets/img/defaultframe.svg"
                  className="defaultFrame"
                />
              </a>
            </div>
          </li>
          <li className="hex">
            <div className="hexIn">
              <a
                className="hexLink"
                href="https://www.hridayamheartcarecentre.com/"
                target="_blank"
              >
                <img
                  // src="https://d33wubrfki0l68.cloudfront.net/518a4e1de9fa16c00f5a898fe33efac202346449/eadbc/community/assets/img/masters.jpg"
                  src={hridayam_logo}
                  alt="US Masters"
                />
                <div className="desc">
                  <div className="hexDesc">Hridayam Heart Care Center</div>
                  {/* <div className="hexDesc author">Healthcare Consultancy Firms in Maharashtra</div> */}
                </div>
                <img
                  src="https://d33wubrfki0l68.cloudfront.net/2cf7ea43dc427e8092ab92837b0f2a3d006ed448/4875d/assets/img/hoverframe.svg"
                  className="hoverFrame"
                />
                <img
                  src="https://d33wubrfki0l68.cloudfront.net/0c24d63303fd772a293a5e229bd0f00aef1cd95a/e72cc/assets/img/defaultframe.svg"
                  className="defaultFrame"
                />
              </a>
            </div>
          </li>
          <li className="hex">
            <div className="hexIn">
              <a
                className="hexLink"
                href="https://rpdaga.com/"
                target="_blank"
              >
                <img
                  // src="https://d33wubrfki0l68.cloudfront.net/518a4e1de9fa16c00f5a898fe33efac202346449/eadbc/community/assets/img/masters.jpg"
                  src={rpdaga_logo}
                  alt="US Masters"
                />
                <div className="desc">
                  <div className="hexDesc">R.P Daga</div>
                  <div className="hexDesc author">Chartered Accountant</div>
                </div>
                <img
                  src="https://d33wubrfki0l68.cloudfront.net/2cf7ea43dc427e8092ab92837b0f2a3d006ed448/4875d/assets/img/hoverframe.svg"
                  className="hoverFrame"
                />
                <img
                  src="https://d33wubrfki0l68.cloudfront.net/0c24d63303fd772a293a5e229bd0f00aef1cd95a/e72cc/assets/img/defaultframe.svg"
                  className="defaultFrame"
                />
              </a>
            </div>
          </li>
          <li className="hex">
            <div className="hexIn">
              <a
                className="hexLink"
                href="https://nareshsharmaphotography.com/"
                target="_blank"
              >
                <img
                  // src="https://d33wubrfki0l68.cloudfront.net/518a4e1de9fa16c00f5a898fe33efac202346449/eadbc/community/assets/img/masters.jpg"
                  src={naresh_logo}
                  alt="US Masters"
                />
                <div className="desc">
                  <div className="hexDesc">Naresh Sharma Photography</div>
                  {/* <div className="hexDesc author">Chartered Accountant</div> */}
                </div>
                <img
                  src="https://d33wubrfki0l68.cloudfront.net/2cf7ea43dc427e8092ab92837b0f2a3d006ed448/4875d/assets/img/hoverframe.svg"
                  className="hoverFrame"
                />
                <img
                  src="https://d33wubrfki0l68.cloudfront.net/0c24d63303fd772a293a5e229bd0f00aef1cd95a/e72cc/assets/img/defaultframe.svg"
                  className="defaultFrame"
                />
              </a>
            </div>
          </li>
          <li className="hex">
            <div className="hexIn">
              <a
                className="hexLink"
                href="https://wealthcreationn.com/"
                target="_blank"
              >
                <img
                  // src="https://d33wubrfki0l68.cloudfront.net/518a4e1de9fa16c00f5a898fe33efac202346449/eadbc/community/assets/img/masters.jpg"
                  src={wealth_logo}
                  alt="US Masters"
                />
                <div className="desc">
                  <div className="hexDesc">Wealth Creationn</div>
                  {/* <div className="hexDesc author">Chartered Accountant</div> */}
                </div>
                <img
                  src="https://d33wubrfki0l68.cloudfront.net/2cf7ea43dc427e8092ab92837b0f2a3d006ed448/4875d/assets/img/hoverframe.svg"
                  className="hoverFrame"
                />
                <img
                  src="https://d33wubrfki0l68.cloudfront.net/0c24d63303fd772a293a5e229bd0f00aef1cd95a/e72cc/assets/img/defaultframe.svg"
                  className="defaultFrame"
                />
              </a>
            </div>
          </li>
          <li className="hex">
            <div className="hexIn">
              <a
                className="hexLink"
                href="https://www.guddygold.com/"
                target="_blank"
              >
                <img
                  // src="https://d33wubrfki0l68.cloudfront.net/518a4e1de9fa16c00f5a898fe33efac202346449/eadbc/community/assets/img/masters.jpg"
                  src={guddi_logo}
                  alt="US Masters"
                />
                <div className="desc">
                  <div className="hexDesc">Guddy Gold</div>
                  <div className="hexDesc author">Sanjay Uttam group</div>
                </div>
                <img
                  src="https://d33wubrfki0l68.cloudfront.net/2cf7ea43dc427e8092ab92837b0f2a3d006ed448/4875d/assets/img/hoverframe.svg"
                  className="hoverFrame"
                />
                <img
                  src="https://d33wubrfki0l68.cloudfront.net/0c24d63303fd772a293a5e229bd0f00aef1cd95a/e72cc/assets/img/defaultframe.svg"
                  className="defaultFrame"
                />
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

{/* <div className="downTriangle-background">
  <a href="#">
    <div className="hex-container">
      <img
        className="hex-backImage"
        src="https://d33wubrfki0l68.cloudfront.net/a94ef192b0f545ef9c902eaf1c1c0fb4589332ef/eb2b4/assets/img/morebuttonstates.svg"
      />
      <div className="hexagon">MORE</div>
    </div>
  </a>
</div> */}
</section>

    </>
  );
}